import { configureStore } from "@reduxjs/toolkit";
import navReducer from "../redux/navReducer";
import notificationReducer from "../redux/notificationReducer";
import adminReducer from "../redux/adminReducer";
import sessionReducer from "../redux/sessionReducer";
import exercisesReduce from "../redux/exerciseReducer";
import sessionFormatReducer from "../redux/sessionFormatReducer";
import gymtReducer from "../redux/gymReducer";

const store = configureStore({
  reducer: {
    navbar: navReducer,
    notification: notificationReducer,
    admin: adminReducer,
    sessions: sessionReducer,
    exercises: exercisesReduce,
    sessionFormats: sessionFormatReducer,
    gym: gymtReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export const dispatch = store.dispatch;
export default store;
